export default function pluralize(word: string, count: number, pluralForm?: string): string {
  const pluralized = pluralForm || `${word}s`;
  return count === 1 ? word : pluralized;
}